import { remove } from "lodash";
import { thor } from "../../typings/thor";
import { LokiCreateOrganizationDialogController } from "./create-organization-dialog.controller";
import { LokiUpdateOrganizationDialogController } from "./update-organization-dialog.controller";
import { STATE } from "../../thor.const";
import { Enums } from "../../thor.enums";
import { MonextContract } from "../../typings/payment";

export class LokiOrganizationsController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$state",
        "$translate",
        "$window",
        "lokiFilterService",
        "searchService",
        "sitesService",
        "contractService",
        "toaster"
    ];

    public isLoading: boolean;
    public limit: number;
    public noDealerIcon: string = require("../../../assets/icons/no-dealer-icon.png");
    public organizations: thor.Organization[];

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        private $mdMedia: ng.material.IMedia,
        private $state: ng.ui.IStateService,
        $translate: ng.translate.ITranslateService,
        private $window: ng.IWindowService,
        public lokiFilterService,
        private searchService,
        public sitesService,
        private contractService,
        private toaster
    ) {
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.limit = 20;
        this.search();
    }

    public loadMoreOrganizations() {
        this.limit += 20;
    }

    public openCreateOrganizationDialog(event) {
        this.$mdDialog
            .show({
                controller: LokiCreateOrganizationDialogController,
                controllerAs: "createOrganizationCtrl",
                template: require("./create-organization-dialog.html"),
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                fullscreen: this.$mdMedia("xs")
            })
            .then((organization: thor.Organization) =>
                this.$mdDialog
                    .show(
                        this.$mdDialog
                            .alert()
                            .clickOutsideToClose(false)
                            .title(this.$t("nouvelle_etude"))
                            .htmlContent(this.$t("login_n", [organization.login]))
                            .ok(this.$t("ok"))
                    )
                    .then(() =>
                        // add new organization to list on dialog closing
                        this.organizations.splice(
                            this.organizations.findIndex(o => o.login > organization.login),
                            0,
                            organization
                        )
                    )
            )
            .catch(error => {
                this.$log.error(error);
                this.toaster.show(this.$t("une_erreur_est_survenue_sauvegarde_impossible"), true);
            });
    }

    public openUpdateOrganizationDialog(event, organization: thor.Organization) {
        let monextContracts;
        this.contractService
        .getMonext(organization?.id)
        .then((data: MonextContract[]) => {
            monextContracts = data;

            this.$mdDialog
            .show({
                controller: LokiUpdateOrganizationDialogController,
                controllerAs: "updateOrganizationCtrl",
                template: require("./update-organization-dialog.html"),
                locals: {
                    organization,
                    monextContracts
                },
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false,
                fullscreen: this.$mdMedia("xs")
            })
            .then((modifiedOrganization: thor.Organization) => {
                remove(this.organizations, (elem: any) => {
                    return elem.id === modifiedOrganization.id;
                });
                this.organizations.push(modifiedOrganization);
            })
            .catch(angular.noop);
        });
    }

    public search() {
        this.organizations = [];
        this.isLoading = true;

        const filterParams = {
            authorized_site: this.sitesService.isAuctionDomain()
                ? Enums.Site.Auction
                : `contains:${Enums.Site.Interencheres}`
        };

        this.searchService
            .getOrganizations(filterParams)
            .then(result => {
                this.organizations = result.items;
                this.isLoading = false;
            })
            .catch(error => {
                this.$log.error("Error while getting all organizations", error);
                this.toaster.show(this.$t("impossible_de_recuperer_la_liste_des_etudes"), true);
            });
    }

    public loginAs(organizationId) {
        const salesListUrl = this.$state.href(STATE.V2.HOME.name, {}, { absolute: true });

        this.$window.open(`${salesListUrl}?oId=${organizationId}`, "_blank");
    }
}
